// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1HTcZ","label":"Completed_label__-3NcS"};